import { Box, styled } from '@mui/material';

export const BeneficiarySelectCardStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
});

export const BeneficiaryDrawerAccordionStyled = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  boxShadow: 'none',
  position: 'initial',
  borderRadius: '4px',
}));

export const BeneficiaryDrawerAccordionDetailsStyled = styled(Box)(
  ({ theme }) => ({
    borderTop: `1px solid ${theme.palette.primaryMedium.main}`,
    padding: theme.spacing(3),
    background: theme.palette.primaryLight.main,
  })
);
